// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/sleeve-spring/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const sleeveSpringEN: PageEntry = {
  id: "post.huelsenfeder",
  locale: "en",
  slug: "sleeve-spring",
  seo: {
    title: "Glossary: Sleeve spring explained simply | Dietz GmbH",
    description: "A sleeve spring is a special type of spring that is wrapped in a cylindrical shape with a sleeve or casing. This design provides additional protection for the spring and allows pre",
  },
  type: "post",
  h1: "Glossary: Sleeve spring explained simply",
  intro: "A sleeve spring is a special type of spring that is wrapped in a cylindrical shape with a sleeve or casing. This design provides additional protection for the spring and allows precise control of the spring movement. Sleeve springs are often used in applications where uniform force distribution and reduced friction are required. Selecting the right material and construction for sleeve springs is critical to ensure their performance and longevity in various applications.",
  blocks: [

  ],
};
